import React from 'react';
import { Link } from 'react-router-dom';

const ServiceBlock = ({ data }) => {
    const { bg, img, title, description,URL } = data;
    return (
        <div className="service-block-style-two col-lg-4 col-md-6 col-sm-12">
            <div className="inner-box bg-white">
                <div className="hidden-image" style={{ backgroundImage: `url(${bg})` }}></div>
                <div className="icon">
                    <img src={img} alt="" />
                </div>
                <h5><Link to={URL}>{title}</Link></h5>
                <div className="text" style={{'fontSize': 'large'}}>{description}</div>
                <Link to={URL} className="read-more"><span><img src="images/services/arrow-right.png" alt="arrow" /></span> Read More</Link>
            </div>
        </div>
    );
};

export default ServiceBlock;